import React, {useCallback, useEffect, useState} from "react";
import {withRouter} from "react-router-dom";
import {Loading} from "../../components/loading";
import {Col, Descriptions, Divider, message, Row, Typography} from "antd";
import AccountList from "../account/component/list";
import ManagerList from "../manager/component/list";
import BusinessRepo from "../../repository/business";
import BusinessEdit from "./components/edit";

const { Title } = Typography;

const BusinessDetails = withRouter(({match}) => {
  const { business_id } = match.params;
  const [loading, setLoading] = useState(true);
  const [business, setBusiness] = useState({});

  const fetchBusiness = useCallback(() => {
    setLoading(true);
    BusinessRepo.fetch(business_id).then(
      result => {
        setBusiness(result.data);
      },
      error => {
        console.error(error.response);
        message.error('Error getting business details');
      }
    ).finally(() => setLoading(false));
  }, [business_id]);

  useEffect(() => {
    fetchBusiness();
  }, [fetchBusiness]);

  return (
    <Loading spinning={loading}>
      <Title level={2}>
        {business.name}
        <BusinessEdit business={business} onClose={() => fetchBusiness()} />
      </Title>

      <Row>
        <Descriptions bordered>
          <Descriptions.Item label="Alias" span={3}>{business.alias}</Descriptions.Item>
          <Descriptions.Item label="Slug" span={2}>{business.slug}</Descriptions.Item>
          <Descriptions.Item label="Tax ID" span={2}>{business.tax_id}</Descriptions.Item>
          <Descriptions.Item label="Contact e-mail" span={3}>{business.email}</Descriptions.Item>
          <Descriptions.Item label="Contact phone" span={2}>{business.phone}</Descriptions.Item>
          <Descriptions.Item label="Country" span={2}>{business.country}</Descriptions.Item>
        </Descriptions>
      </Row>

      <Divider/>

      <Row gutter={10}>
        <Col span={12}>
          <AccountList business={business} />
        </Col>
        <Col span={12}>
          <ManagerList business={business} />
        </Col>
      </Row>
    </Loading>
  );
});

export default BusinessDetails;